import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableMarketplaceSecondaryActionRework = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableMarketplaceSecondaryActionRework);
};
